import { render } from "./InquiryForm.vue?vue&type=template&id=65da2c9a&scoped=true"
import script from "./InquiryForm.vue?vue&type=script&lang=js"
export * from "./InquiryForm.vue?vue&type=script&lang=js"

import "./InquiryForm.vue?vue&type=style&index=0&id=65da2c9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65da2c9a"

export default script